import React from 'react'
import { Link } from "react-router-dom";
import { logOutRedirectCall } from '../../../pages/Common/RedirectPathMange';

export default function TopBar() {
  return (
    <nav className="navbar">
      <div className="col-12">
        <div className="navbar-header">
        <a class="bars" ></a>
          <Link className="navbar-brand" to="/">Food For Good</Link>
        </div>
        <ul className="nav navbar-nav navbar-right">
          <li className><Link to="/setting" className="js-right-sidebar" data-close="true"><i className="zmdi zmdi-settings zmdi-hc-spin" /></Link></li>
          <li><Link onClick={() => logOutRedirectCall()} to="/sign-in" className="mega-menu" data-close="true"><i className="zmdi zmdi-power" /></Link></li>
        </ul>
      </div>
    </nav>
  )
}
